import View from "../account/views/AddressesFormView";
import components from "./components.js";
components.define("js-addresses-form", View);